import { useState, useContext } from "react";
import {
  Grid,
  Box,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
import moment from "moment";
//Import from project
import "../../../Style/pagestyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import LoadingPage from "../../../Utils/LoadingPage";
import EmptyData from "../../Include/EmptyData/EmptyData";
import FooterPagination from "../../../Utils/FooterPagination";
import { ButtonCreate, SearchTextField } from "../../../Utils/Component";
import PerformanceForm from "./PerformanceForm";
import PerformanceAction from "./PerformanceAction";
import { SelectSubjectByClassId } from "../../Include/DynamicSelect/DynamicSelect";
import useGetPerformancePagination from "../../../Hooks/useGetPerformancePagination";
import useWithDimension from "../../../Hooks/useWithDimension";

export default function Performance({ classId }) {
  //
  const { language, t } = useContext(AuthContext);
  const { width } = useWithDimension();

  // Filters state
  const [subject, setSubject] = useState({ id: "", title: "" });

  // console.log("classI sss sd::", classId);

  // Table and pagination data
  const {
    page,
    limit,
    loading,
    refetch,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetPerformancePagination({
    classId: classId || "",
    subjectId: subject?.id || "",
  });

  // console.log("paginationData::", paginationData);

  // Create form modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {/* ================== Filters ================== */}
      <Box sx={{ marginTop: "10px" }}>
        <Grid container spacing={3}>
          {/* Search Input */}
          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className="text-field"
              handleSearch={handleSearch}
            />
          </Grid>

          {/* Subject Filter */}
          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_subject")}
            </Typography>
            <SelectSubjectByClassId
              value={subject}
              classId={classId}
              onChange={setSubject}
              className="text-field"
            />
          </Grid>

          {/* From Date */}
          {/* <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_start_date")}
            </Typography>
            <SelectDatePicker value={fromDate} onChange={setFromDate} />
          </Grid> */}

          {/* To Date */}
          {/* <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_end_date")}
            </Typography>
            <SelectDatePicker value={toDate} onChange={setToDate} />
          </Grid> */}

          {/* Create Button */}
          <Grid item xs={12} sm={4} md={6} lg={7.2} xl={8}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn="btn-create"
              classIcon="icon-add"
            />

            {open && (
              <PerformanceForm
                open={open}
                classId={classId}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      {/* ================== Table ================== */}
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="teaching-time-table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="5%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("page_performance_type")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_name")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_subject")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_description")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_remark")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="5%"
                />
              </TableRow>
            </TableHead>

            <TableBody className="body">
              {loading ? (
                <TableRow className="body-row">
                  <TableCell
                    colSpan={8}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              ) : tableData?.length === 0 || tableData?.length === undefined ? (
                <TableRow className="body-row">
                  <TableCell colSpan={8} className="body-cell">
                    <EmptyData />
                  </TableCell>
                </TableRow>
              ) : (
                tableData?.map((row, index) => {
                  // console.log("row::", row);
                  return (
                    <TableRow className="body-row" key={row._id || index}>
                      <TableCell className="body-cell-start">
                        {index + 1}
                      </TableCell>

                      {/* <TableCell className="body-cell">
                      {row?.date && moment(row?.date).format("DD MMM YYYY")}
                      </TableCell> */}

                      <TableCell className="body-cell">
                        {language === "en"
                          ? row?.performanceTypeId?.enName
                          : row?.performanceTypeId?.khName}{" "}
                        (
                        {row?.performanceTypeId?.date &&
                          moment(row?.performanceTypeId?.date).format(
                            "DD MMM YYYY",
                          )}
                        )
                      </TableCell>

                      <TableCell className="body-cell">
                        {row?.studentId?.familyName +
                          " " +
                          row?.studentId?.studentName}
                      </TableCell>

                      <TableCell className="body-cell">
                        {language === "en"
                          ? row?.subjectId?.enName
                          : row?.subjectId?.khName}
                      </TableCell>

                      <TableCell
                        className="body-cell"
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {row?.description}
                      </TableCell>

                      <TableCell className="body-cell">{row?.remark}</TableCell>

                      <TableCell className="body-cell-end" align="right">
                        <PerformanceAction
                          editData={row}
                          classId={classId}
                          setRefetch={refetch}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* ================== Pagination ================== */}
      <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      />
    </div>
  );
}
